import Observable from "zen-observable"
import AuthStreamBase from "@irati/auth/streams/auth/base"

export type OnNext<T> = (data: Partial<T>) => void

interface Props<T> {
  streams: AuthStreamBase<any>[],
  key: keyof T
}

/**
 * @description: Listen to a heirachy of streams, first in list will take precedence. Searches for 'key' given.
 */
export default class ObserveWithPriority<T> {
  private listeners: ZenObservable.Subscription[] = []
  private observers: ZenObservable.SubscriptionObserver<Partial<T>>[] = []
  private data: any[] = []
  private key: keyof T

  constructor(props: Props<T>) {
    this.key = props.key
    props.streams.forEach((stream, index) => {
      this.listenToStream(index, stream, () => {
        this.observers.forEach((observer) => {
          observer.next(this.getData())
        })
      })
    })
  }

  subscribe(onNext: OnNext<T>) {
    return new Observable<Partial<T>>((observer) => {
      this.observers.push(observer)

      return () => {
        this.observers = this.observers.filter((t) => t !== observer)
      }
    }).subscribe(onNext)
  }

  getData(): Partial<T> {
    let obj = {}
    this.data
      .slice(0, this.data.length)
      .reverse()
      .forEach((test) => {
        if (test && test[this.key]) {
          obj = test
        }
      })

    return obj
  }

  private listenToStream(index: number, service: AuthStreamBase<any>, update: () => void) {
    this.listeners[index] = service.subscribe(
      (data) => {
        this.data[index] = data
        update()
      },
      undefined,
      () => {
        this.data[index] = null
        update()
        this.listenToStream(index, service, update)
      }
    )
  }
}
